<template>
  <header class="site-header">
    <div class="header-inner">
      <div class="header-left">
        <a class="logo-link" href="/" aria-label="Sportemocracy">
          <img class="logo" src="@/assets/sportemocracy_white.svg" alt="Sportemocracy" />
        </a>
      </div>
      <button
        class="menu-toggle"
        type="button"
        aria-label="Apri menu"
        :aria-expanded="isMenuOpen.toString()"
        aria-controls="primary-nav"
        @click="toggleMenu"
      >
        <span class="menu-icon" aria-hidden="true">
          <span></span>
          <span></span>
        </span>
      </button>
      <div class="header-center">
        <nav
          id="primary-nav"
          class="header-nav"
          :class="{ 'is-open': isMenuOpen }"
          aria-label="Navigazione principale"
        >
          <router-link class="nav-link" to="/chi-siamo" @click="closeMenu">Chi siamo</router-link>
          <router-link class="nav-link" to="/come-lavoriamo" @click="closeMenu">Come lavoriamo</router-link>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: $primary;
  padding-top: env(safe-area-inset-top, 0px);
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  padding-left: max(16px, env(safe-area-inset-left, 0px));
  padding-right: max(16px, env(safe-area-inset-right, 0px));
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-center {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
}

.logo-link {
  display: inline-flex;
  align-items: center;
}

.logo {
  height: 1rem;
  width: auto;
  display: block;
}

.header-nav {
  position: relative;
  display: none;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px 16px;
  background-color: $primary;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.nav-link {
  color: $white;
  text-decoration: none;
  font-size: 0.95rem;
  line-height: 1.2;
}

.nav-link:hover {
  color: $primary-light;
}

.logo-link:focus-visible,
.nav-link:focus-visible,
.menu-toggle:focus-visible {
  outline: 2px solid $white;
  outline-offset: 3px;
  border-radius: 6px;
}

.menu-toggle {
  margin-left: auto;
  background: transparent;
  border: 1px solid $white;
  color: $white;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.menu-icon {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
}

.menu-icon span {
  display: block;
  width: 16px;
  height: 2px;
  background-color: $white;
}

.header-nav.is-open {
  display: flex;
}

@media (min-width: 900px) and (orientation: landscape) {
  .header-inner {
    max-width: none;
    width: 100%;
    padding: 24px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
  }

  .logo {
    height: 2rem;
  }

  .menu-toggle {
    display: none;
  }

  .header-center {
    display: flex;
    justify-content: center;
    position: static;
    left: auto;
    right: auto;
    top: auto;
    grid-column: 2;
  }

  .header-nav {
    display: flex;
    position: static;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    flex-direction: row;
    justify-content: center;
    gap: 24px;
  }

  .header-left {
    grid-column: 1;
    justify-self: start;
  }
}
</style>
